import { Component, OnInit } from '@angular/core';
import { SimpleModalComponent } from 'ngx-simple-modal';
import { NotificationDetail } from './../../../../interfaces/modal/notificacion-detail.interface';
import { Router } from '@angular/router';
import { NotificationService } from 'src/app/services/notification.service';
import { AdviserService } from 'src/app/services/adviser.service';

@Component({
  selector: 'app-details-notification',
  templateUrl: './details-notification.component.html',
  styleUrls: ['./details-notification.component.css']
})
export class DetailsNotificationComponent extends SimpleModalComponent<NotificationDetail, null> implements NotificationDetail {
  title: string;
  message: string;
  type: string;
  id: number;
  date: Date;
  petitionId?: number;
  docName?: string;
  userId?: number;
  constructor(
    private router: Router,
    private nService: NotificationService,
    private adviserService: AdviserService
  ) {
    super();
  }

  viewDocument() {
    let contractNumber = this.obtenerNumeroContrato(this.message)
    this.nService.notificationsModalStatus.next(false);
    if(this.docName)
      this.router.navigate(["ver-documento"], { queryParams: { petitionId: this.petitionId, docName: this.docName, userId: this.userId, contractNumber: contractNumber ?? contractNumber  } });
    else
      this.adviserService.redirectToProcess.next({ petitionId: this.petitionId, userId: this.userId });
  }

  obtenerNumeroContrato(texto: string): string {
    const regex = /número de contrato: (\d+[-]\d+)/;
    const match = texto.match(regex);
    return match ? match[1] : '';
  }

}
